/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import { comparatorQtr } from '../../../../../SharedModules/utilities/utilities';

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(amount1?.toString().split('$')[1]);
  } else {
    amt1 = amount1;
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(amount2?.toString().split('$')[1]);
  } else {
    amt2 = amount1;
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
export const TableHeaderForInvoiceNumber = [
  {
    headerName: 'Actions',
    field: 'action',
    cellRenderer: 'ActionCellRender',
    maxWidth: Styles.Width_100,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'frr-overflow-visible',
    editable: false,
    sortable: false,
    showCheckboxIcon: false,
    hideFilterIcon: true,
    filter: false,
    resizable: true,
    suppressMenu: false,
  },
  {
    headerName: 'Invoice Number',
    field: 'invoiceNum',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    sort: 'asc',
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Rebate Program',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Quarter',
    field: 'qtr',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_135,
    comparator: comparatorQtr,

    sortingOrder: ['desc', 'asc'],
    autoHeight: true,
    wrapText: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderMFG',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];

export const TableHeaderForQuarter = [
  {
    headerName: 'Actions',
    field: 'action',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: false,
    resizable: true,
    maxWidth: Styles.Width_100,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Quarter',
    field: 'invRecQtr',
    editable: false,
    sortable: true,
    sort: 'desc',
    minWidth: Styles.Width_150,
    cellRenderer: 'NDCCellRender',
    comparator: comparatorQtr,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Principal paid ',
    field: 'principalPaidAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    isTextColorRed: true,
    minWidth: Styles.Width_250,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'principalPaidAmtRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Interest Paid',
    field: 'intrestPaidAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    isTextColorRed: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'intrestPaidAmtRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
